export const CREATE_EVENT_SECTION_START = 'CREATE_EVENT_SECTION_START';
export const CREATE_EVENT_SECTION_SUCCESS = 'CREATE_EVENT_SECTION_SUCCESS';
export const CREATE_EVENT_SECTION_FAIL = 'CREATE_EVENT_SECTION_FAIL';

export const FETCH_EVENT_SECTIONS_START = 'FETCH_EVENT_SECTIONS_START';
export const FETCH_EVENT_SECTIONS_SUCCESS = 'FETCH_EVENT_SECTIONS_SUCCESS';
export const FETCH_EVENT_SECTIONS_FAIL = 'FETCH_EVENT_SECTIONS_FAIL';

export const UPDATE_EVENT_SECTION_START = 'UPDATE_EVENT_SECTION_START';
export const UPDATE_EVENT_SECTION_SUCCESS = 'UPDATE_EVENT_SECTION_SUCCESS';
export const UPDATE_EVENT_SECTION_FAIL = 'UPDATE_EVENT_SECTION_FAIL';

export const DELETE_EVENT_SECTION_START = 'DELETE_EVENT_SECTION_START';
export const DELETE_EVENT_SECTION_SUCCESS = 'DELETE_EVENT_SECTION_SUCCESS';
export const DELETE_EVENT_SECTION_FAIL = 'DELETE_EVENT_SECTION_FAIL';

export const ASSIGN_EVENT_TO_SECTION_START = 'ASSIGN_EVENT_TO_SECTION_START';
export const ASSIGN_EVENT_TO_SECTION_SUCCESS =
  'ASSIGN_EVENT_TO_SECTION_SUCCESS';
export const ASSIGN_EVENT_TO_SECTION_FAIL = 'ASSIGN_EVENT_TO_SECTION_FAIL';

export const RESET_ASSIGN_EVENT_TO_SECTION = 'RESET_ASSIGN_EVENT_TO_SECTION';

export const RESET_CREATE_EVENT_SECTION = 'RESET_CREATE_EVENT_SECTION';

export const RESET_EVENT_SECTION_STORE = 'RESET_EVENT_SECTION_STORE';

export type EventSectionActionTypes =
  | typeof CREATE_EVENT_SECTION_START
  | typeof CREATE_EVENT_SECTION_SUCCESS
  | typeof CREATE_EVENT_SECTION_FAIL
  | typeof FETCH_EVENT_SECTIONS_START
  | typeof FETCH_EVENT_SECTIONS_SUCCESS
  | typeof FETCH_EVENT_SECTIONS_FAIL
  | typeof UPDATE_EVENT_SECTION_START
  | typeof UPDATE_EVENT_SECTION_SUCCESS
  | typeof UPDATE_EVENT_SECTION_FAIL
  | typeof DELETE_EVENT_SECTION_START
  | typeof DELETE_EVENT_SECTION_SUCCESS
  | typeof DELETE_EVENT_SECTION_FAIL
  | typeof ASSIGN_EVENT_TO_SECTION_START
  | typeof ASSIGN_EVENT_TO_SECTION_SUCCESS
  | typeof ASSIGN_EVENT_TO_SECTION_FAIL
  | typeof RESET_ASSIGN_EVENT_TO_SECTION
  | typeof RESET_CREATE_EVENT_SECTION
  | typeof RESET_EVENT_SECTION_STORE;
